export interface ForumTopic {
  id: string;
  ownerId: string;
  authorName: string;
  title: string;
  category: string;
  body: string;
  views: number;
  repliesCount: number;
  createdAt: string;
}

export interface ForumReply {
  id: string;
  topicId: string;
  userId: string;
  authorName: string;
  authorInitials: string;
  content: string;
  createdAt: string;
}

export const forumCategories = [
  'Général',
  'Technologie',
  'Entrepreneuriat',
  'Emploi & Carrière',
  'Formation',
  'Freelance',
  'Immobilier',
  'Aide & Support',
];

export const mockForumTopics: ForumTopic[] = [
  {
    id: 'topic-1',
    ownerId: 'user-1',
    authorName: 'Ama Koffi',
    title: 'Comment démarrer son activité freelance au Togo ?',
    category: 'Freelance',
    body: "Bonjour à tous ! Je suis développeur web et je souhaite me lancer en freelance à Lomé. Quelles sont les démarches administratives à faire ? Faut-il obligatoirement créer une entreprise pour facturer ses premiers clients ? Merci pour vos retours d'expérience.",
    views: 1284,
    repliesCount: 3,
    createdAt: '2026-08-19',
  },
  {
    id: 'topic-2',
    ownerId: 'user-2',
    authorName: 'Kossi Mensah',
    title: 'Meilleures ressources gratuites pour apprendre le développement web',
    category: 'Formation',
    body: "Je débute complètement en programmation et je cherche des ressources gratuites et de qualité pour apprendre le développement web en français. Qu'est-ce que vous recommandez : tutoriels YouTube, plateformes en ligne, bootcamps ? Je vise un premier emploi dans l'année.",
    views: 942,
    repliesCount: 2,
    createdAt: '2026-08-18',
  },
  {
    id: 'topic-3',
    ownerId: 'user-3',
    authorName: 'Afi Edorh',
    title: 'Retours d\'expérience sur les paiements Mobile Money pour un e-commerce',
    category: 'Entrepreneuriat',
    body: "J'ai lancé une petite boutique en ligne et je veux intégrer les paiements Mobile Money (Flooz, T-Money). Quels prestataires utilisez-vous ? Comment gérer les commissions et les délais de reversement ? Vos retours m'aideraient beaucoup à faire le bon choix.",
    views: 753,
    repliesCount: 2,
    createdAt: '2026-08-17',
  },
  {
    id: 'topic-4',
    ownerId: 'user-4',
    authorName: 'Yao Agbeko',
    title: 'Recherche cofondateur(trice) tech pour une startup edtech',
    category: 'Emploi & Carrière',
    body: "Nous construisons une plateforme edtech pour l'Afrique francophone et cherchons un(e) cofondateur(trice) technique (React / Node ou équivalent). Idéalement basé(e) à Lomé ou disponible à distance. Si vous êtes motivé(e) par l'impact éducatif, contactez-moi.",
    views: 618,
    repliesCount: 3,
    createdAt: '2026-08-16',
  },
  {
    id: 'topic-5',
    ownerId: 'user-5',
    authorName: 'Ekoué Dossou',
    title: 'React, Vue ou Svelte : quel framework choisir en 2026 ?',
    category: 'Technologie',
    body: "J'hésite entre React, Vue et Svelte pour un nouveau projet SaaS. Je connais déjà un peu React. Quel est selon vous le meilleur choix en 2026 en termes d'employabilité sur le marché africain et de performance ? Arguments et retours concrets bienvenus.",
    views: 1090,
    repliesCount: 2,
    createdAt: '2026-08-15',
  },
  {
    id: 'topic-6',
    ownerId: 'user-6',
    authorName: 'Mawuli Tchalla',
    title: 'Conseils pour décrocher ses premiers clients internationaux',
    category: 'Freelance',
    body: "Je suis graphiste freelance et je veux me positionner sur les plateformes internationales. Comment décrocher ses premiers clients quand on n'a pas encore d'avis ? Quels canaux ont le mieux fonctionné pour vous ? Je pars de zéro, tout conseil est précieux.",
    views: 536,
    repliesCount: 2,
    createdAt: '2026-08-14',
  },
  {
    id: 'topic-7',
    ownerId: 'user-7',
    authorName: 'Abla Soglo',
    title: 'Bienvenue sur le forum : présentez-vous !',
    category: 'Général',
    body: "Ce sujet sert à faire connaissance. Présentez-vous en quelques mots : qui vous êtes, ce que vous faites et ce que vous attendez de la communauté WorldApeiron. C'est aussi l'occasion de dire bonjour aux nouveaux membres !",
    views: 2031,
    repliesCount: 3,
    createdAt: '2026-08-12',
  },
];

export const mockForumReplies: Record<string, ForumReply[]> = {
  'topic-1': [
    {
      id: 'reply-1-1',
      topicId: 'topic-1',
      userId: 'user-8',
      authorName: 'Kodjo Assigbé',
      authorInitials: 'KA',
      content: "Pour commencer, tu n'es pas obligé de créer une société tout de suite. Beaucoup de freelances démarrent en tant qu'entrepreneur individuel et régularisent ensuite. Le plus important est de déclarer tes revenus.",
      createdAt: '2026-08-19',
    },
    {
      id: 'reply-1-2',
      topicId: 'topic-1',
      userId: 'user-9',
      authorName: 'Sika Gbado',
      authorInitials: 'SG',
      content: "J'ai commencé en 2024 avec un simple statut d'auto-entrepreneur. Mes premiers clients locaux payaient en espèces, puis je suis passé au Mobile Money pour les clients à distance. Crée d'abord un portfolio solide, ça rassure plus que n'importe quel papier.",
      createdAt: '2026-08-19',
    },
    {
      id: 'reply-1-3',
      topicId: 'topic-1',
      userId: 'user-10',
      authorName: 'Félix Agbodjan',
      authorInitials: 'FA',
      content: 'Je confirme. Et pense à ouvrir un compte bancaire pro pour séparer tes finances personnelles de celles du business. Bon courage !',
      createdAt: '2026-08-20',
    },
  ],
  'topic-2': [
    {
      id: 'reply-2-1',
      topicId: 'topic-2',
      userId: 'user-1',
      authorName: 'Ama Koffi',
      authorInitials: 'AK',
      content: 'Commence par HTML/CSS/JavaScript sur FreeCodeCamp ou OpenClassrooms, puis enchaîne avec React. La documentation officielle est très bien faite. Fixe-toi un projet perso dès le début pour pratiquer.',
      createdAt: '2026-08-18',
    },
    {
      id: 'reply-2-2',
      topicId: 'topic-2',
      userId: 'user-11',
      authorName: 'Nadège Amouzou',
      authorInitials: 'NA',
      content: 'Les formations de WorldApeiron Learn sont excellentes pour débuter, et elles sont en français. En parallèle, rejoins une communauté pour ne pas rester bloqué seul.',
      createdAt: '2026-08-18',
    },
  ],
  'topic-3': [
    {
      id: 'reply-3-1',
      topicId: 'topic-3',
      userId: 'user-6',
      authorName: 'Mawuli Tchalla',
      authorInitials: 'MT',
      content: "Flooz et T-Money ont tous les deux des API pour marchands. Les commissions tournent autour de 1 à 2 %. Vérifie bien les délais de reversement qui varient selon le prestataire, certains reversent sous 24h, d'autres sous 48-72h.",
      createdAt: '2026-08-17',
    },
    {
      id: 'reply-3-2',
      topicId: 'topic-3',
      userId: 'user-12',
      authorName: 'Tété Kpodar',
      authorInitials: 'TK',
      content: "Pense aussi à proposer un paiement à la livraison en complément, ça rassure énormément les clients au début. Et garde une trace claire de chaque transaction.",
      createdAt: '2026-08-17',
    },
  ],
  'topic-4': [
    {
      id: 'reply-4-1',
      topicId: 'topic-4',
      userId: 'user-5',
      authorName: 'Ekoué Dossou',
      authorInitials: 'ED',
      content: "Très intéressant ! Je suis dev full-stack React/Node basé à Lomé. Peux-tu partager plus de détails sur la vision du produit et le modèle de répartition ? Je serais curieux d'en discuter.",
      createdAt: '2026-08-16',
    },
    {
      id: 'reply-4-2',
      topicId: 'topic-4',
      userId: 'user-13',
      authorName: 'Awa Diallo',
      authorInitials: 'AD',
      content: "Bonne initiative ! L'edtech a un vrai potentiel en Afrique francophone. Je te conseille de préciser le niveau d'engagement attendu (temps plein vs temps partiel) pour attirer les bons profils.",
      createdAt: '2026-08-16',
    },
    {
      id: 'reply-4-3',
      topicId: 'topic-4',
      userId: 'user-14',
      authorName: 'Kwame Adjovi',
      authorInitials: 'KA',
      content: 'Je suis plus côté design produit. Si vous cherchez quelqu\'un pour la partie UX plus tard, faites-moi signe. Bonne chance pour le recrutement !',
      createdAt: '2026-08-17',
    },
  ],
  'topic-5': [
    {
      id: 'reply-5-1',
      topicId: 'topic-5',
      userId: 'user-15',
      authorName: 'Ayité Lawson',
      authorInitials: 'AL',
      content: "Pour l'employabilité en Afrique, React reste imbattable : le plus d'offres, le plus de ressources, le plus gros écosystème. Svelte est génial pour la performance mais le marché est plus restreint. Vue est un bon compromis.",
      createdAt: '2026-08-15',
    },
    {
      id: 'reply-5-2',
      topicId: 'topic-5',
      userId: 'user-16',
      authorName: 'Dela Agbéko',
      authorInitials: 'DA',
      content: 'Je rejoins Ayité. Reste sur React si tu le connais déjà, concentre ton énergie sur le produit plutôt que sur un nouveau framework. Tu gagneras du temps.',
      createdAt: '2026-08-15',
    },
  ],
  'topic-6': [
    {
      id: 'reply-6-1',
      topicId: 'topic-6',
      userId: 'user-3',
      authorName: 'Afi Edorh',
      authorInitials: 'AE',
      content: "Commence par construire un portfolio en ligne impeccable et crée un profil sur les plateformes type Fiverr/Upwork. Les premiers clients viendront peut-être de ton réseau : n'hésite pas à le solliciter.",
      createdAt: '2026-08-14',
    },
    {
      id: 'reply-6-2',
      topicId: 'topic-6',
      userId: 'user-17',
      authorName: 'Koffi Adoté',
      authorInitials: 'KA',
      content: 'La clé, c\'est la régularité et la patience. Les 3 premiers mois sont durs, puis les avis commencent à arriver. Réponds vite aux messages, sois fiable, et ça finit par décoller.',
      createdAt: '2026-08-14',
    },
  ],
  'topic-7': [
    {
      id: 'reply-7-1',
      topicId: 'topic-7',
      userId: 'user-2',
      authorName: 'Kossi Mensah',
      authorInitials: 'KM',
      content: 'Salut à tous ! Kossi, en reconversion vers le dev web. Ravie de rejoindre cette communauté pour apprendre et échanger.',
      createdAt: '2026-08-12',
    },
    {
      id: 'reply-7-2',
      topicId: 'topic-7',
      userId: 'user-18',
      authorName: 'Essi Koudjo',
      authorInitials: 'EK',
      content: 'Bienvenue Kossi ! Moi c\'est Essi, community manager. J\'espère que ce forum deviendra un vrai lieu d\'entraide.',
      createdAt: '2026-08-13',
    },
    {
      id: 'reply-7-3',
      topicId: 'topic-7',
      userId: 'user-19',
      authorName: 'Atsu Kpeglo',
      authorInitials: 'AK',
      content: 'Content de voir la communauté grandir. Je suis consultant en marketing digital, à dispo pour aider sur ces sujets.',
      createdAt: '2026-08-13',
    },
  ],
};